module.exports = __webpack_public_path__ + "img/3.6854aa0.jpg";